/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { BaseCommentBaseWithExtendedReplies } from './BaseCommentBaseWithExtendedReplies';
import { GeneralFeedbackExtra } from './GeneralFeedbackExtra';
const GeneralFeedbackCommentBaseWithExtendedRepliesParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(GeneralFeedbackExtra, BaseCommentBaseWithExtendedReplies);
export class GeneralFeedbackCommentBaseWithExtendedReplies extends BaseCommentBaseWithExtendedReplies {
    static decode(input) {
        return GeneralFeedbackCommentBaseWithExtendedRepliesParser.decode(input).map(res => new GeneralFeedbackCommentBaseWithExtendedReplies(res));
    }
    static unsafeDecode(input) {
        return GeneralFeedbackCommentBaseWithExtendedReplies.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GeneralFeedbackCommentBaseWithExtendedRepliesParser.encode(data);
    }
    static schema() {
        return GeneralFeedbackCommentBaseWithExtendedRepliesParser.schema();
    }
}
